<footer class="d-flex flex-wrap justify-content-between align-items-center border-top bg-white">
  <ul class="nav">
    <li class="nav-item">
      <input
        type="button"
        class="nav-link px-2 text-muted"
        (click)="openInNewTab('https://www.phishlab.de/datenschutz')"
        value="Datenschutz" />
    </li>
    <li class="nav-item">
      <input
        type="button"
        class="nav-link px-2 text-muted"
        (click)="openInNewTab('https://www.viadee.de/impressum/')"
        value="Impressum" />
    </li>
    <li class="nav-item">
      <input
        type="button"
        class="nav-link px-2 text-muted"
        (click)="openInNewTab('https://www.phishlab.de/nutzungsbedingungen')"
        value="Nutzungsbedingungen" />
    </li>
    <li class="nav-item">
      <a class="nav-link px-2 text-muted" href="mailto:phishlab@viadee.de">Kontakt</a>
    </li>
    @if (isAuthenticated()) {
      <li class="nav-item">
        <input type="button" class="nav-link px-2 text-muted" (click)="openFeedbackModal()" value="Feedback" />
      </li>
    }
  </ul>
  <div class="d-flex px-2">
    <p class="mb-0 text-muted">Created with</p>
    <i class="bi bi-heart-fill mb-0 ms-1 me-1 text-danger"></i>
    <p class="mb-0 text-muted">by</p>
    <input
      type="button"
      class="mb-0 nav-link px-2 lookLikeLink"
      (click)="openInNewTab('https://www.viadee.de')"
      value="viadee" />
  </div>
</footer>
